/* eslint-disable func-names , array-callback-return, prefer-arrow-callback, no-unused-vars*/
import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import { CHANGE_EVENT } from '../constants/AppConstants';
import ProjectionConstants from '../constants/ProjectionConstants';
import FinancialStoriesStore from './FinancialStoriesStore';
import _ from 'lodash';
import ProjectionApiUtils from '../utils/ProjectionApiUtils';

let accountIdArray = [];

let _projectionSummary = {};
let _earningsAndCommitments = [];
let _projectionAlertsAmountValue = '';
let _projectionAlertsNotificationBoolean = '';
let _projectionSettingsFlag;
let _categoryTagsForProjectionTab = [];
let _userTagsForProjectionTab = [];
const _alertsNotificationFlag = '';
let _currency = '';
let _getNotificationAmount = '';
let _onLoad = true;
let _earningIdArray = [];
let _categoryTags = [];
let _userTags = [];
let _alertAmount;
let _alertFlag;
let _forecasts = [];
let _demoDoneClicked = false;
let _activityIndicator = false;
let _isCrunching = false;
let _optoutClicked = true;
let _setAmountToDecimal = 0;
let _putProjectionErrorMEssage = {};
let _setProjectionPreferenceErrorHandling = false;
let _setPutProjectionPreferenceErrorHandling = false;
let _thresholdAmount = 0;

let status = 200;
let errorObject = {};
let pageMode = 'wheel';
let cancelButtonFlag = true;
let accountId = '';
let demoHeaderFlag = true;

let overdraftAmount = 0;
let accountData = {};
const ProjectionStore = Object.assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
   * @param {function} callback
   */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
   * Allow views to unbind listeners before dismounting.
   *
   * @param  {Function} callback    Function to unbind.
   */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },
  setThresholdAmount(value) {
    _thresholdAmount = value;
  },
  getThresholdAmount() {
    return _thresholdAmount;
  },
  getProjectionSummary() {
    return _projectionSummary || [];
  },
  getEarningsAndCommitments() {
    return _earningsAndCommitments || [];
  },
  getProjectionAlertsAmountValue() {
    return _projectionAlertsAmountValue[0];
  },
  getProjectionAlertsNotificationBoolean() {
    return _projectionAlertsNotificationBoolean;
  },
  getProjectionSettingsFlag() {
    return _projectionSettingsFlag;
  },
  getCategoryTagsForProjectionTab() {
    return _categoryTagsForProjectionTab || [];
  },
  getUserTagsForProjectionTab() {
    return _userTagsForProjectionTab || [];
  },
  getNotificationAmount() {
    return _getNotificationAmount || [];
  },
  getCurrency() {
    return _currency;
  },
  getOnload() {
    return _onLoad;
  },
  getTourFlag() {
    return _projectionSettingsFlag;
  },
  getEarningId() {
    return _earningIdArray || [];
  },
  getCategoryTags() {
    return _categoryTags || [];
  },
  getUserTags() {
    return _userTags || [];
  },
  setProjectionAlertAmount(alertAmount) {
    _alertAmount = alertAmount;
  },
  setProjectionNotification(alertNotficationFlag) {
    _alertFlag = alertNotficationFlag;
  },
  getProjectionAlertAmount() {
    return _alertAmount;
  },
  getProjectionNotificationFlag() {
    return _alertsNotificationFlag;
  },
  getForecasts() {
    return _forecasts;
  },
  isDemoDoneCliked() {
    return _demoDoneClicked;
  },
  getActivityIndicator() {
    return _activityIndicator;
  },
  getCrunching() {
    return _isCrunching;
  },
  getActualAmountWithDecimal() {
    return _setAmountToDecimal;
  },
  getProjectionPreferenceErrorHandling() {
    return _setProjectionPreferenceErrorHandling;
  },
  putProjectionPreferenceErrorHandling() {
    return _setPutProjectionPreferenceErrorHandling;
  },
  putProjectionErrorMEssage() {
    return _putProjectionErrorMEssage;
  },

  // new ui logics
  getStatus() {
    return status;
  },
  getErrorObject() {
    return errorObject;
  },

  getStatusOfId(id) {
    let ID = id;
    let status;
    _.filter(accountIdArray, (accountData) => {
      if (accountData.id === ID) {
        status = accountData.status;
      }
    });
    return status;
  },
  getDataOfId(id) {
    let ID = id;
    let data = {};
    _.filter(accountIdArray, (accountData) => {
      if (accountData.id === ID) {
        data = accountData.body;
        _projectionSummary = accountData.body;
      }
    });
    return data;
  },
  getErrorObjOfId(id) {
    let ID = id;
    let error = {};
    _.filter(accountIdArray, (accountData) => {
      if (accountData.id === ID) {
        error = accountData.body;
      }
    });
    return error;
  },
  getPageMode() {
    return pageMode;
  },
  getPageData() {
    return _projectionSummary;
  },
  getAccountId() {
    return accountId;
  },
  setVariables(crunch) {
    _isCrunching = crunch;
  },
  setAccountId(id) {
    accountId = id;
  },
  setPageMode(mode) {
    pageMode = mode;
  },
  setCancelButtonFlag(flag) {
    cancelButtonFlag = flag;
  },
  getCancelButtonFlag() {
    return cancelButtonFlag;
  },
  getHeaderDemoFlag() {
    return demoHeaderFlag;
  },
  setDemoHeaderFlag(flag) {
    demoHeaderFlag = flag;
  },
  setOverdraftAmountData(data) {
    accountData = data;
  },
  getOverAmount() {
    return overdraftAmount;
  },
  getData() {
    if (accountData.accountDetails !== undefined) {
      if (
        accountData.accountDetails.overDraft !== null ||
        accountData.accountDetails.overDraft !== undefined
      ) {
        return accountData.accountDetails.overDraft;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  },
});

ProjectionStore.dispatchToken = AppDispatcher.register((payload) => {
  const action = payload.action;
  switch (action.actionType) {
    // new ui logics
    case ProjectionConstants.ACCOUNT_ID:
      accountId = action.data;
      break;
    case ProjectionConstants.PAGE_MODE:
      pageMode = action.data;
      ProjectionStore.emitChange();
      break;
    case ProjectionConstants.PAGE_DATA:
      _projectionSummary = action.data;
      ProjectionStore.emitChange();
      break;
    case ProjectionConstants.GET_PROJECTION_SUMMARY:
      ProjectionApiUtils.getProjectionSummary(action.data);
      ProjectionStore.emitChange();
      break;
    case ProjectionConstants.GET_PROJECTION_SUMMARY_SUCCESS:
      accountIdArray.push({
        id: action.accountId,
        body: action.data,
        status: action.status,
      });
      status = action.status;
      ProjectionStore.emitChange();
      break;
    case ProjectionConstants.GET_PROJECTION_SUMMARY_FAILURE:
      status = action.status;
      errorObject = action.data;
      accountIdArray.push({
        id: action.accountId,
        body: action.data,
        status: action.status,
      });
      break;
    case ProjectionConstants.REQUEST_EARNINGS_COMMITMENTS:
      ProjectionApiUtils.getEarningCommitments(accountId);
      break;
    case ProjectionConstants.REQUEST_EARNINGS_COMMITMENTS_SUCCESS:
      _earningsAndCommitments = action.data;
      _projectionSettingsFlag = action.data.enabled;
      _categoryTags = [];
      action.data.essentialSpends.map((essentialTags) => {
        essentialTags.categorytags.map((cbTags) => {
          if (cbTags.enabledFlag) {
            _categoryTags.push(cbTags.id);
          }
        });
      });
      _userTags = [];
      action.data.essentialSpends.map((essentialTags) => {
        essentialTags.usertags.map((userTags) => {
          if (userTags.enabledFlag) {
            _userTags.push(userTags.id);
          }
        });
      });
      _earningIdArray = [];
      action.data.earnings.map((earningid) => {
        if (earningid.earningsEnabledFlag) {
          _earningIdArray.push(earningid.earningsId);
        }
      });
      _projectionAlertsAmountValue = action.data.alerts.map((alerts) => {
        return alerts.alertsAmount;
      });
      _setAmountToDecimal = action.data.alerts.map((alerts) => {
        return alerts.alertsAmount;
      });
      _projectionAlertsNotificationBoolean = action.data.alerts.map(
        (alerts) => {
          return alerts.notificationFlag;
        }
      );
      _onLoad = true;
      _isCrunching = false;
      ProjectionStore.emitChange();
      break;
    case ProjectionConstants.GET_PROJECTION_PREFERENCE_ERROR:
      _setProjectionPreferenceErrorHandling = true;
      break;
    case ProjectionConstants.PUT_PROJECTION_PREFERENCE_ERROR:
      _isCrunching = false;
      if (action.data !== undefined) {
        _putProjectionErrorMEssage = action.data;
        _activityIndicator = false;
        FinancialStoriesStore.setOnloadForProjections(false);
        _setPutProjectionPreferenceErrorHandling = true;
        ProjectionStore.emitChange();
      }
      break;
    case ProjectionConstants.DONE_PROJECTIONS:
      _demoDoneClicked = false;
      ProjectionApiUtils.projectionsUpdate(
        action.data.cpProjectionPreferences,
        action.accountId
      );
      _isCrunching = false;
      _activityIndicator = true;
      _optoutClicked = action.data.from === 'optout';
      if (_optoutClicked) {
        _activityIndicator = true;
      }
      ProjectionStore.emitChange();
      break;
    case ProjectionConstants.DONE_PROJECTIONS_SUCCESS:
      _isCrunching = !_optoutClicked;
      _activityIndicator = false;
      _setPutProjectionPreferenceErrorHandling = false;
      ProjectionApiUtils.getProjectionSummary(action.accountId);

      if (_optoutClicked) {
        _activityIndicator = false;
      }
      ProjectionStore.emitChange();
      break;
    case ProjectionConstants.CATEGORY_TAGS_FOR_PROJECTION_TAB:
      _categoryTags = action.data;
      break;
    case ProjectionConstants.USER_TAGS_FOR_PROJECTION_TAB:
      _userTags = action.data;
      break;
    case ProjectionConstants.SET_AMOUNT_FOR_NOTIFICATION_ALERT:
      _getNotificationAmount = action.data;
      break;
    case ProjectionConstants.GET_EARNINGS_ID:
      _earningIdArray = action.data;
      break;
    case ProjectionConstants.PROJECTION_TOUR_DONE_CLICKED:
      _demoDoneClicked = true;
      break;
    case ProjectionConstants.PROJECTION_CRUNCH_BACK_CLICKED:
      _isCrunching = false;
      break;
    case ProjectionConstants.PROJECTION_LEAVE_SETUP:
      _categoryTags = [];
      _userTags = [];
      _earningIdArray = [];
      _earningsAndCommitments.essentialSpends.map((essentialTags) => {
        essentialTags.categorytags.map((cbTags) => {
          if (cbTags.enabledFlag) {
            _categoryTags.push(cbTags.id);
          }
        });
      });
      _earningsAndCommitments.essentialSpends.map((essentialTags) => {
        essentialTags.usertags.map((userTags) => {
          if (userTags.enabledFlag) {
            _userTags.push(userTags.id);
          }
        });
      });
      _earningsAndCommitments.earnings.map((earningid) => {
        if (earningid.enabled) {
          _earningIdArray.push(earningid.earningsId);
        }
      });
      _projectionAlertsAmountValue = _earningsAndCommitments.alerts.map(
        (alerts) => {
          return alerts.alertsAmount;
        }
      );
      _setAmountToDecimal = _earningsAndCommitments.alerts.map((alerts) => {
        return alerts.alertsAmount;
      });
      _projectionAlertsNotificationBoolean = _earningsAndCommitments.alerts.map(
        (alerts) => {
          return alerts.notificationFlag;
        }
      );
      _onLoad = false;
      break;
    case ProjectionConstants.SET_MODAL_FLAG:
      _setPutProjectionPreferenceErrorHandling = action.data;
      ProjectionStore.emitChange();
      break;
    case ProjectionConstants.GET_ACCOUNT_ID:
      accountId = action.data;
      break;
    case ProjectionConstants.RESET_SETTINGS:
      _earningsAndCommitments = [];
      break;
    default:
  }
});

export default ProjectionStore;
